import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { Response } from '@/common/types';
import { API_URL } from '@/dtos';
import { Trigger, TriggerCategoryType } from '@/modules/HealthPlan/HealthPlan.types.ts';
import { useCurrentOrganization } from '@/modules/core/hooks';

import { QUERY_KEY } from '../../queries/useGetTriggers.query';

const useCreateTriggerQuery = (onSuccess?: (trigger: Trigger) => void) => {
  const { observingOrganization } = useCurrentOrganization();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    (payload: Trigger) => api.post<Trigger, Response<Trigger>, Trigger>(API_URL.TRIGGERS, payload),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        if (onSuccess) {
          onSuccess(data.data);
        }
      },
    }
  );

  const createTrigger = (name: string, triggerCategoryType: TriggerCategoryType) =>
    mutateAsync({
      name,
      trigger_category_type: triggerCategoryType,
      organization_id: _.toNumber(observingOrganization.id),
    });

  return { createTrigger, isLoading };
};

export default useCreateTriggerQuery;
